module.exports = __webpack_public_path__ + "cbp-logo-surego.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=[name].[ext]!./app/images/cbp-logo-surego.png
// module id = ./node_modules/file-loader/index.js?name=[name].[ext]!./app/images/cbp-logo-surego.png
// module chunks = 13